export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-latin-ext-400-normal.woff2?41e5252efd360c72f3fc50613295698d";